import { render, staticRenderFns } from "./checkout-field-checkbox.vue?vue&type=template&id=6668a418&"
import script from "./checkout-field-checkbox.vue?vue&type=script&lang=js&"
export * from "./checkout-field-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports